import * as log from "loglevel";
import {levelGroup} from '../Level';
import {gameConfig} from '../../config/GameConfig';
import {game} from '../../GameCore';
import {slowToStandstill} from '../../sprites/player/Player';
import {gameState} from '../../config/GameState';
import {startUsingNewTileset, queueOutsideTiles} from '../backgrounds/Backgrounds';
import {startCountdownTimer, stopCountdownTimer} from '../../timer/GameTimer';
import {getGameManager} from '../../GameManager';
import {queueObstacle, resetObstacles} from '../ground/Obstacles';
import {_allowPlatforms, allowPlatforms} from '../platforms/Platforms';
import {playSound} from '../../audio/AudioManager';

var offsetX: number,

    stageStartTime: number,
    stageCurrentTime: number,
    pauseDuration: number,

    stageStartTime: number,
    stageCurrentTime: number,
    stageTimerUpdateEvent: Phaser.TimerEvent,
    stageStartX: number;


export function addStageTimerListeners()
{
    pauseDuration = 0;

    game.onResume.add(() =>
        {

            pauseDuration += game.time.pauseDuration / 1000;
            log.warn('new pause duration:', pauseDuration)
        });
}


/**
 * reset the current stage when we start a new game
 */
export function resetStage()
{
    //  reset stage vars

    gameState.level =
    {
        currentLevel: 0,
        currentStage: 0,
        isOutside: false
    };

    offsetX = 0;

    //  reset speed multiplier

    gameState.player.multiplier = 1;

    //  reset the current level indicator

    getGameManager().setCurrentLevel(0);

    //  start timing a new stage

    startStage();
}


/**
 * stop the timer and clear all events
 */
export function stopStageTimer()
{
    if (stageTimerUpdateEvent) game.time.events.remove(stageTimerUpdateEvent);
}


/**
 * start a new stage
 */
export function startStage()
{
    //  clear any current timers

    stopStageTimer();

    //  save the current time so we know when we started the stage

    //stageStartX = levelGroup.x;
    //stageStartTime = new Date().getTime();
    pauseDuration = 0;

    stageStartTime = game.time.totalElapsedSeconds();

    //log.warn('start time: ', game.time.totalElapsedSeconds(), pauseDuration)

    //  start tracking time

    stageTimerUpdateEvent = game.time.events.loop(100, trackProgressInStage);

    //  start counting down time again

    startCountdownTimer();
}



/**
 * when the stage timer loop event fires, check how long we've been playing this stage
 */
function trackProgressInStage()
{
    //  if time on current level is below the level duration count, stop here

    var currentProgress: number;

    //  check current progress

    currentProgress = getCurrentLevelProgress();

    //if (getCurrentLevelProgress() < gameConfig.level.levelDuration)
    if (currentProgress <= 100)
    {
        //  display progress as a percentage of the stage time

        getGameManager().progress(currentProgress + '%');

        return;
    }

    //  otherwise, it's time to go to the next level

    endStage();
}


/**
 * end a stage
 */
export function endStage()
{
    //  increment the current stage number

    incrementStageValue();

    //  check we have enough stages; if not, loop back round to zero

    if (gameState.level.currentStage >= gameConfig.level.stages.length) gameState.level.currentStage = 0;

    //  is the new stage outside?

    gameState.level.isOutside = ! gameState.level.isOutside;

    //  don't create any more platforms

    allowPlatforms(false);


    //  stop the timer

    stopStageTimer();

    if (gameState.level.isOutside)
    {
        //  we're moving outside - let's prep the outside sprites and get ready to ask a question

        queueOutsideTiles();

        //  stop the countdown timer

        stopCountdownTimer();
    }
    else
    {
        ////  start timing the new indoors stage
        //
        //startStage();
        //
        ////  tell the background to start using the new tileset
        //
        ////startUsingNewTileset();
        ////
        //////  queue a new obstacle
        ////
        ////resetObstacles();
        //
    }
}


/**
 * go to the next stage; if we've gone through all stages then go back to zero
 */
function incrementStageValue()
{
    //  increment the stage value

    gameState.level.currentStage ++;

    //  if we've reached the end of the list, go back to the start

    if (gameState.level.currentStage >= gameConfig.level.stages.length) gameState.level.currentStage = 0;

    //  increment the current level value; un like the stage value, this just keeps increasing

    gameState.level.currentLevel ++;

    //getGameManager().setCurrentLevel(gameState.level.currentLevel);
}



/**
 * calculate the amount of time we've been on the current stage
 * @returns {number}
 */
function getCurrentLevelProgress() : number
{
    var currentPercentage: number;

    currentPercentage = ((game.time.totalElapsedSeconds() - (stageStartTime + pauseDuration)) / gameConfig.level.levelDuration) * 100;

    //log.debug('currentPercentage', gameConfig.level.levelDuration, (game.time.totalElapsedSeconds() - pauseDuration), stageStartTime)

    //log.debug(game.time.totalElapsedSeconds(), (stageStartTime + pauseDuration))


    return currentPercentage;

    //return new Date().getTime() - stageStartTime;

    //return Math.abs(levelGroup.x - stageStartX);
}


// WEBPACK FOOTER //
// ./src/ts/game/level/stages/StageManager.ts